<template>
  <section>
    <nav-component :titulo="'Roles'" :texto="'Agregar rol'" :link="can('roles.registrar') ? { name: 'AgregarRol' }: null"/>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Roles</b-breadcrumb-item> 
    </b-breadcrumb>
    <div class="columns">
        <div class="column">
          <b-select v-model="perPage" @input="onPerPageChange">
            <option :value="5">5 por página</option>
            <option :value="10">10 por página</option>
            <option :value="15">15 por página</option>
            <option :value="20">20 por página</option>
            <option :value="null">Todos</option>
          </b-select>
        </div>
      </div>

    <div class="has-text-right mb-3">
      <b-button type="is-info is-light" icon-left="shield-search" @click="abrirAuditoria"
        v-if="can('roles.auditoria_permisos')">
        Auditar permisos
      </b-button>
    </div>

    <b-table class="box" :data="roles" :per-page="perPage || total || 1" :paginated="true" :pagination-simple="false"
    :current-page="currentPage" :backend-pagination="true" :total="total" @page-change="onPageChange"
    :pagination-position="'bottom'" :default-sort-direction="'asc'" :pagination-rounded="true">
      <b-table-column field="nombre" label="Nombre del rol" sortable searchable v-slot="props">
        {{ props.row.nombre }}
      </b-table-column>

      <b-table-column field="usuarios" label="Cantidad de usuarios" sortable searchable v-slot="props">
        {{ props.row.numUsuarios }} usuarios con este rol
      </b-table-column>

      <b-table-column field="editar" label="Editar" v-slot="props" v-if="can('roles.editar')">
        <b-button type="is-warning" icon-left="pen" tag="router-link" :to="{ name: 'EditarRol', params: { id: props.row.id } }" v-if="props.row.nombre !== 'Administrador'">
          Editar
        </b-button>
        <span v-else>NO EDITABLE</span>
      </b-table-column>
    </b-table>

    <!-- Auditoría de permisos (solo lectura): qué acciones del API aún no tienen checkbox
         en el formulario de roles y por lo tanto no se pueden restringir. -->
    <b-modal v-model="mostrarAuditoria" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: 92vw; max-width: 1000px">
        <header class="modal-card-head has-background-info">
          <p class="modal-card-title has-text-white">Auditoría de permisos</p>
          <button type="button" class="delete" @click="mostrarAuditoria = false" />
        </header>
        <section class="modal-card-body">
          <p v-if="cargandoAuditoria" class="has-text-centered py-4">Cargando…</p>
          <template v-else-if="auditoria">
            <p class="is-size-7 has-text-grey mb-2">
              Acciones del API: <strong>{{ auditoria.resumen.acciones_totales }}</strong> ·
              con checkbox: <strong>{{ auditoria.resumen.acciones_con_checkbox }}</strong> ·
              SIN checkbox: <strong>{{ auditoria.resumen.acciones_sin_checkbox }}</strong> ·
              claves del formulario: {{ auditoria.resumen.claves_en_catalogo }} ·
              roles: {{ auditoria.resumen.roles }}
            </p>
            <p class="is-size-7">
              Las acciones <strong>sin checkbox</strong> todavía no se pueden restringir desde
              el formulario de roles: hoy las puede llamar cualquier usuario con sesión. Es la
              lista de lo que falta por administrar.
            </p>
            <p v-if="auditoria.acciones_sin_checkbox.length === 0" class="has-text-success">
              Todas las acciones del API tienen checkbox.
            </p>
            <b-table v-else :data="auditoria.acciones_sin_checkbox" hoverable>
              <b-table-column field="accion" label="Acción del API sin checkbox" v-slot="props">
                <span class="is-size-7">{{ props.row.accion }}</span>
              </b-table-column>
              <b-table-column field="roles_sin_clave" label="Roles sin la clave" v-slot="props">
                <span class="is-size-7">{{ props.row.roles_sin_clave }} de {{ auditoria.resumen.roles }}</span>
              </b-table-column>
            </b-table>
          </template>
        </section>
        <footer class="modal-card-foot">
          <b-button label="Cerrar" @click="mostrarAuditoria = false" />
        </footer>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>
<script>
import NavComponent from '../Extras/NavComponent'
import HttpService from '../../Servicios/HttpService'

export default {
  name: 'RolesComponent',
  components: { NavComponent },

  data: () => ({
    cargando: false,
    roles: [],
    perPage: 5,
    currentPage: 1,
    total: 0,
    auditoria: null,
    mostrarAuditoria: false,
    cargandoAuditoria: false,
  }),

  mounted() {
    this.obtenerRoles()
  },

  methods: {
    /** Auditoría (solo lectura) de la superficie de permisos del sistema. */
    async abrirAuditoria() {
      this.mostrarAuditoria = true
      this.cargandoAuditoria = true

      try {
        this.auditoria = await HttpService.obtenerConConsultas('roles.php', {
          accion: 'auditoria_permisos',
        })
      } catch (error) {
        this.auditoria = null
        this.$buefy.toast.open({
          type: 'is-danger',
          message: (error && error.message) || 'No se pudo cargar la auditoría de permisos',
        })
      } finally {
        this.cargandoAuditoria = false
      }
    },

    obtenerRoles() {
      this.cargando = true
      let payload = {
        accion: 'obtener',
        pagina: this.perPage === null ? null : this.currentPage,
        limite: this.perPage,
      }

      HttpService.obtenerConConsultas('roles.php', payload)
        .then(resultado => {
          this.roles = resultado.roles
          this.total = resultado.total
          this.cargando = false
        })
    },

    onPageChange(page) {
      this.currentPage = page
      this.obtenerRoles()
    },

    onPerPageChange() {
      this.currentPage = 1
      this.obtenerRoles()
    },
  }
}
</script>
